import React, { createContext, useState } from 'react';

const UserContext = createContext(null);

function UserContextProvider(props) {
  const [user, setUser] = useState(null);

  return (
    <UserContext.Provider
      value={{
        user,
        setUser: setUser,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
}

export { UserContextProvider, UserContext as userContext };
